import axios from "axios";

axios.defaults.baseURL = process.env.APP_URL;
axios.defaults.headers.common['X-Locale'] = document.documentElement.lang || 'en';

export default axios;
